export default __webpack_public_path__ + "static/media/kubernets.9c2b252d.svg";